import TodoList from "./Component/TodoList";

function App() {
  return (
    <>
      <TodoList />

      <div
        className=""
        style={{
          backgroundColor: "#11998e",
          textAlign: "center",
          color: "white",
          paddingTop: "2vh",
          paddingBottom: "2vh",
          fontWeight: "bolder",
          position: "fixed",
          bottom: "0",
          width: "100%",
        }}
      >
        Apna Task Manager 🎯 | Copyright © Rajarshi Samaddar 2023.
      </div>
    </>
  );
}

export default App;
